import { Gender } from '@senet-uiverse/common';

export interface IProfile {
  first_name: string;
  last_name: string;
  gender: Gender | null;
  birth_date: string;
  username: string;
  phone: string;
  address: string;
  document_id: string;
}

export interface IRequiredField {
  field_type: ERegistrationFieldType;
  required: boolean;
  enabled: boolean;
  extras: {};
}

export interface IRequiredFieldFull extends IRequiredField {
  visible_under_permission: boolean;
  field_display_name: string;
  is_cap_only_field: boolean;
  is_system_field: boolean;
  updated_at: string;
  id: number;
}

export enum ERegistrationFieldType {
  COMMENT = 'comment',
  ID_CARD = 'id_card',
  LAST_NAME = 'last_name',
  MY_NAME = 'my_name',
  NICKNAME = 'nickname',
  PHONE_NUMBER = 'phone_number',
  CAP_LANGUAGE = 'cap_language',
  CENTER = 'center',
  GENDER = 'gender',
  KNOW_ABOUT_US = 'know_about_us',
  ADDRESS = 'address',
  BIRTH_DATE = 'birth_date',
  EMAIL = 'email',
  GAMER_PHOTO = 'gamer_photo',
  PHOTO_ID_CARD = 'photo_id_card',
  USER_GROUP = 'user_group',
  PASSWORD = 'password',
  SUPERADMIN = 'superadmin',
}
